function cookies() {
    function getCookie(name) {
        let cookies = document.cookie.split('; ');
        for (let cookie of cookies) {
            let [key, value] = cookie.split('=');
            if (key === name) return value;
        }
        return null;
    }

    function setCookie(name, value, days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }

    function acceptCookies() {
        setCookie('familijneCookiesAccepted', 'true', 30);
        document.querySelector(".cookies").style.display = "none";
    }

    let cookiesAccept = document.querySelector(".cookies-accept");
    if (cookiesAccept) {
        cookiesAccept.addEventListener("click", acceptCookies);
    }

    window.onload = function () {
        if (!getCookie('familijneCookiesAccepted')) {
            document.querySelector(".cookies").style.display = "block";
        }
    }

}
cookies()
